import React from 'react';
import { Link } from 'react-router-dom';
import AIMix from '../../assets/teach2.jpg';
import ITspt from '../../assets/ITSupport.webp';
import NOCent from '.././../assets/NOCenter.jpg';
import onsiteEng from '../../assets/emma3.jpg';
import SoftDev from '../../assets/mobile-app-developers.webp';
import heroBackground from '../../assets/data.webp'; // Add your hero background image here

const SolutionsPage = () => {
  return (
    <section className="py-16">
      {/* Hero Section with Image Background */}
      <div
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBackground})` }}
      >
        <div className="container mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white">
            Our Solutions
          </h1>
          <p className="text-xl md:text-2xl text-white mt-4 animate-fadeIn delay-2s">
            Empowering your business with innovative IT solutions
          </p>
        </div>
        {/* Optional Overlay for better text contrast */}
        <div className="absolute inset-0 bg-black opacity-40"></div>
      </div>

      {/* Solutions Overview */}
      <div className="container mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {/* Solution Item */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-2xl animate-slideUp">
          <img
            src={AIMix}
            alt="AI Solutions"
            className="w-full h-64 object-cover"
          />
          <div className="p-6">
            <h2 className="text-3xl font-semibold text-gray-800">
              AI and Machine Learning
            </h2>
            <p className="text-gray-600 mt-4">
              Harness the power of AI and machine learning to drive smarter business decisions and automation, transforming data into actionable insights.
            </p>
          </div>
        </div>

        {/* Solution Item */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-2xl animate-slideUp delay-1s">
          <img
            src={ITspt}
            alt="IT Support"
            className="w-full h-64 object-cover"
          />
          <div className="p-6">
            <h2 className="text-3xl font-semibold text-gray-800">IT Support</h2>
            <p className="text-gray-600 mt-4">
              Offering rapid and reliable technical support to ensure your IT infrastructure runs smoothly, minimizing downtime and maximizing productivity.
            </p>
          </div>
        </div>

        {/* Solution Item */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-2xl animate-slideUp delay-2s">
          <img
            src={NOCent}
            alt="Network Operations Center"
            className="w-full h-64 object-cover"
          />
          <div className="p-6">
            <h2 className="text-3xl font-semibold text-gray-800">
              Network Operations Center
            </h2>
            <p className="text-gray-600 mt-4">
              Our NOC is operational 24/7, ensuring your network is secure and functioning optimally, with prompt responses to any issues that arise.
            </p>
          </div>
        </div>

        {/* Solution Item */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-2xl animate-slideUp delay-3s">
          <img
            src={onsiteEng}
            alt="On-Site Engineers"
            className="w-full h-64 object-cover"
          />
          <div className="p-6">
            <h2 className="text-3xl font-semibold text-gray-800">
              On-Site Engineers
            </h2>
            <p className="text-gray-600 mt-4">
              Providing expert on-site support to keep your IT systems and networks secure, reliable, and ready for the future.
            </p>
          </div>
        </div>

        {/* Solution Item */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-2xl animate-slideUp delay-4s">
          <img
            src={SoftDev}
            alt="Software Development"
            className="w-full h-64 object-cover"
          />
          <div className="p-6">
            <h2 className="text-3xl font-semibold text-gray-800">
              Software Development
            </h2>
            <p className="text-gray-600 mt-4">
              Crafting customized software solutions to meet your specific business needs, driving growth with secure, scalable, and high-performance applications.
            </p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-[#023B8D] to-[#C5B358] -mb-24 py-16 p-5">
        <div className="container mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-white mb-6 animate-bounce">
            Transform Your Business Today
          </h2>
          <p className="text-white text-lg md:text-xl mb-8 animate-fadeIn delay-1s">
            Contact us to explore how our solutions can help your business thrive in the digital age.
          </p>
          <Link to="/ContactPage">
            <button className="bg-[#C5B358] text-blue-900 py-3 px-8 rounded-full transition duration-300 hover:bg-[#c39e2a] hover:scale-110 animate-pulse">
              Get in Touch
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SolutionsPage;
